<template>
  <vue-navigation-bar :options="navbarOptions" />
</template>
<script>

  import { modulesRoles } from '@/data/modulesRoles'

  export default {
    data () {
      return {
        navbarOptions: {
          elementId: 'main-navbar',
          isUsingVueRouter: true,
          mobileBreakpoint: 992,
          brandImagePath: './',
          brandImageAltText: 'brand-image',
          collapseButtonOpenColor: '#661c23',
          collapseButtonCloseColor: '#661c23',
          showBrandImageInMobilePopup: true,
          ariaLabelMainNav: 'Main Navigation',
          tooltipAnimationType: 'shift-away',
          menuOptionsLeft: modulesRoles,
        },
      }
    },
    created() {
      const userRoles = JSON.parse(localStorage.getItem('role')) || []
      const userPermissions = JSON.parse(localStorage.getItem('permissions')) || []

      let filteredModules = JSON.parse(JSON.stringify(modulesRoles))

      filteredModules = filteredModules.map(module => {
        module.subMenuOptions = module.subMenuOptions.filter(opt => {
          let roleOk = false
          let permOk = false

          const hasRole = Array.isArray(opt.role)
          const hasPermission = Array.isArray(opt.permission)

          // Validar roles
          if (hasRole) {
            roleOk = opt.role.some(r => userRoles.includes(r))
          }

          // Validar permisos
          if (hasPermission) {
            permOk = opt.permission.some(p => userPermissions.includes(p))
          }

          // 👉 Público si no tiene role ni permission
          const isPublic = !hasRole && !hasPermission

          return isPublic || roleOk || permOk
        })

        return module
      }).filter(module => module.subMenuOptions.length > 0)

      this.navbarOptions.menuOptionsLeft = filteredModules
    }

  }
</script>

<style lang="scss">
.vnb {
  &__menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }

        &:hover {
          color: #0081ff;

          .vnb__menu-options__option__arrow {
            fill: #0081ff;
          }
        }

        &__icon {
          svg {
            fill: #0081ff !important;
          }
        }
      }
    }
  }

  &__sub-menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }

        color: #000 !important;

        &:hover {
          color: #0081ff !important;
        }
      }
    }
  }
  background: rgb(240 240 240) !important;
  border-radius: 6px !important;
}

.vnb__collapse-button {
  &:focus {
    border: 1px solid none;
    outline: none;
  }

  &:after {
    content: "\F035C";
    font-size: 25px;
    font-weight: 600;
    font-family: "Material Design Icons";
  }

  svg {
    display: none !important;
  }
}

.vnb__popup {
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: scroll !important;

  .vnb__popup__top__close-button {
    &:focus {
      border: 1px solid none;
      outline: none;
    }

    top: 20px;
    right: -33px;

    svg {
      fill: #000 !important;
    }
  }
}
</style>
